import React, { Component } from 'react';


class JobStatusBox extends Component {
    state = {}
    render() { 
        return ( 
            <div className="col-xl-2 jobStatusBox">
                <h3>{this.props.status}</h3>
                <div className={this.props.class} style={{ display: this.props.display}}>
                    <span className="caret"></span>
                    <label>You Are Here</label>
                </div>
            </div>
         )
    }
}
 
export default JobStatusBox;


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/JobStatus/JobStatusBox.jsx